import React from "react";
import { Link } from "react-router-dom";
import "../css/AboutUs.css";

const FEATURES = [
	"Handcrafted & machine-woven premium rugs",
	"Natural fibers & eco-friendly materials",
	"Custom designs for homes & commercial spaces",
	"Manufacturing Units: Bhadohi & Panipat",
	"India — In-house Rug Manufacturing"
];

const AboutUs = () => {
	return (
		<section className="container about-section">
			<div className="about-container">
				<div className="about-row">
					{/* Content Column */}
					<article className="content-column">
						<div className="inner-column">
							<header className="sec-title p-4">
								<div className="title my-4">About Company</div>
								<div className="py-3">
									<h2>
										Crafting Premium Rugs <br /> With
										Tradition & Elegance
									</h2>
								</div>
							</header>

							<p className="text">
								Blumeessa is an India-based manufacturer and
								exporter of premium handmade rugs, specializing
								in hand-tufted wool rugs, hand-knotted rugs,
								jute rugs, and handwoven floor coverings. We
								collaborate with skilled artisans to deliver
								high-quality, design-driven rugs that meet
								international standards of durability, comfort,
								and aesthetics.
							</p>

							<p className="text">
								Our collections blend traditional craftsmanship
								with contemporary design, offering modern,
								abstract, and nature-inspired styles for global
								markets. We primarily serve B2B buyers,
								including retailers, interior designers,
								hospitality projects, and private-label brands
								across the US and Europe. Our focus is ethical
								production, consistent quality, and long-term
								partnerships worldwide.
							</p>

							<ul className="list-style-one">
								{FEATURES.map((item, index) => (
									<li key={index}>{item}</li>
								))}
							</ul>

							<div className="btn-box">
								<Link to="/contact" className="btn-style-one">
									Contact Us
								</Link>
							</div>
						</div>
					</article>

					{/* Image Column */}
					<aside className="image-column">
						<div className="inner-column">
							<figure className="image-1">
								<img
									src="images/aboutus/aboutus_1.jpeg"
									alt="Premium rug manufacturing process"
								/>
							</figure>

							<figure className="image-2">
								<img
									src="images/aboutus/aboutus_2.jpeg"
									alt="Handcrafted wool rugs by artisans"
								/>
							</figure>
						</div>
					</aside>
				</div>
			</div>
		</section>
	);
};

export default AboutUs;
